(function (Drupal, drupalSettings) {
  Drupal.behaviors.leafletEnfance = {
    attach: function (context, settings) {
      const mapElement = context.querySelector(".pole_3 #map");
      if (mapElement && !mapElement.dataset.leafletEnfanceProcessed) {
        mapElement.dataset.leafletEnfanceProcessed = "true";

        const planes = [
          [
            "<strong>Les Jeunes Pousses</strong>Crèche de Nivelles<br>Rue Samiette 3<br>1400 Nivelles<br><a href='tel:067 21 43 82' class='tel'>067 21 43 82</a>",
            50.595739,
            4.315245,
          ],
          [
            "<strong>La Malogne</strong>Crèche de La Louvière<br>Rue de la Malogne 9<br>7100 La Louvière<br><a href='tel:065 21 20 95' class='tel'>065 21 20 95</a>",
            50.473108,
            4.20782,
          ],
          [
            "<strong>La Maison de Justin</strong>Maison d’accueil à Warquignies<br>Rue des Chaufours 27<br>7300 Boussu<br><a href='tel:065 78 25 09' class='tel'>065 78 25 09</a>",
            50.417582,
            3.806986,
          ],
          [
            "<strong>Le Nid Colas</strong>Crèche de Maurage<br>Rue de la Garenne 17 (accès via rue du Roeulx 29)<br>7110 Maurage<br><a href='tel:064 23 51 99' class='tel'>064 23 51 99</a>",
            50.461148,
            4.098947,
          ],
          [
            "<strong>Les Petites Canailles</strong>Crèche de Lobbes<br>Clos des Champs 102<br>6540 Lobbes<br><a href='tel:071 59 94 57' class='tel'>071 59 94 57</a><hr><strong>Accueil extrascolaire de Lobbes</strong>Clos des Champs 102<br>6540 Lobbes",
            50.34763,
            4.268436,
          ],
          [
            "<strong>Accueil extrascolaire des Chartriers à Mons</strong>Rue des Chartriers 12<br>7000 Mons",
            50.450312,
            3.95342,
          ],
          [
            "<strong>Centre du Bien Naître</strong>Rue Ferrer 196<br>7100 Haine-Saint-Paul<br><a href='tel:064 23 33 50' class='tel'>064 23 33 50</a>",
            50.47698,
            4.21654,
          ],
          [
            "<strong>Service de Promotion de la Santé à l’école</strong>Rue Ferrer 196<br>7100 Haine-Saint-Paul",
            50.477284,
            4.216658,
          ],
          [
            "<strong>Les Enfantill’âges</strong>Crèche de Mons<br>Quai des Otages 2<br>7012 Mons<br><a href='tel:065 44 97 95' class='tel'>065 44 97 95</a>",
            50.45460689243926,
            3.924052323311756,
          ],
          [
            "<strong>Les Lutins</strong>Rue de Tamines 18<br>6224 Fleurus<br><a href='tel:071 81 12 86' class='tel'>071 81 12 86</a>",
            50.468931164925934,
            4.587950895930233,
          ],
        ];

        const map = L.map(mapElement).setView([50.5, 3.8], 10);

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> Contributors',
          maxZoom: 18,
        }).addTo(map);

        const jolimontIcon = L.icon({
          iconUrl:
            "/themes/custom/expansion/assets/dist/images/jolimont-map-icon-enfance.png",
          iconSize: [64, 64],
          iconAnchor: [32, 32],
          popupAnchor: [0, -30],
        });

        const markerArray = planes.map(([popupText, lat, lng]) => {
          return L.marker([lat, lng], { icon: jolimontIcon })
            .bindPopup(popupText, { minWidth: 250 })
            .addTo(map);
        });

        const group = L.featureGroup(markerArray);
        map.fitBounds(group.getBounds());
      }
    },
  };
})(Drupal, drupalSettings);
